import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { ButtonGroup } from '@gemini/ui';
import { useTranslation } from 'react-i18next';
import { transactionTypeData } from './data';
const SelectTransactionType = ({ transactionType, handleTransactionTypeChange, }) => {
    const { t } = useTranslation();
    const selectTransactionTypeData = transactionTypeData.map((item) => ({
        ...item,
        label: t(item.label),
    }));
    return (_jsxs(Box, { maxWidth: {
            'breakpoint.md': '512px',
            'breakpoint.xs': '330px',
        }, children: [_jsxs(Box, { typography: "typography.body.14.bold", textAlign: "justify", marginBottom: "spacing.4", children: [t('Transaction_type'), _jsx(Box, { as: "span", children: " *" })] }), _jsx(ButtonGroup, { iconPosition: "start", items: selectTransactionTypeData, label: t('selectType'), name: "selectType", type: "radio", defaultValue: transactionType, onChange: handleTransactionTypeChange })] }));
};
export default SelectTransactionType;
